(function initializeCateringContactPage() {
  if (window.__cateringContactPageLoaded) return;
  window.__cateringContactPageLoaded = true;

  function initializeProvider(page) {
    const provider = page.querySelector('[data-contact-provider]');
    if (!provider || provider.dataset.initialized === 'true') return;

    const loading = provider.querySelector('[data-contact-loading]');
    const providerScript = provider.querySelector('[data-contact-tripleseat-script]');

    const decorate = () => {
      const embeddedForm = provider.querySelector('#tripleseat_embed_form');
      if (!embeddedForm) return false;

      embeddedForm.setAttribute('aria-label', provider.dataset.formHeading || 'Contact form');

      const heading = embeddedForm.querySelector('.row_contact_header h2');
      if (heading && provider.dataset.formHeading) heading.textContent = provider.dataset.formHeading;

      const submit = embeddedForm.querySelector('#lead_submit');
      if (submit) {
        submit.value = provider.dataset.submitLabel || 'Submit';
        submit.classList.add('button', 'button--primary', 'goode-type');
      }

      if (loading) loading.hidden = true;
      provider.dataset.initialized = 'true';
      return true;
    };

    if (decorate()) return;

    const observer = new MutationObserver(() => {
      if (!decorate()) return;
      observer.disconnect();
    });

    observer.observe(provider, { childList: true, subtree: true });

    providerScript?.addEventListener('error', () => {
      observer.disconnect();
      if (!loading) return;
      loading.textContent = 'The contact form is temporarily unavailable. Please call or email our team.';
      loading.setAttribute('role', 'alert');
    });
  }

  function initializeAll(root) {
    root.querySelectorAll('[data-catering-contact-page]').forEach(initializeProvider);
  }

  initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
